import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SalesUser } from '../../../../models/SalesUser';
import { selectAllSalesUsers } from '../../../../state/sales-user/sales-user.selector';
import { loadSalesUsers, changeSalesUserCoins } from '../../../../state/sales-user/sales-user.actions';
import { AddSalesUserCoinsDialogComponent } from './add-sales-user-coins-dialog/add-sales-user-coins-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe, CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { PageHeaderComponent } from '../../../page-header/page-header.component';

@Component({
  selector: 'app-manage-sales-users',
  standalone: true,
  imports: [MatTableModule, MatIconModule, MatButtonModule, AsyncPipe, CommonModule, RouterLink, PageHeaderComponent],
  templateUrl: './manage-sales-users.component.html',
  styleUrl: './manage-sales-users.component.css'
})
export class ManageSalesUsersComponent implements OnInit {
  salesUsers$: Observable<SalesUser[]>;

  constructor(private store: Store, private dialog: MatDialog) {
    this.salesUsers$ = this.store.select(selectAllSalesUsers).pipe(
      map(users => users ?? [])
    );
  }

  ngOnInit(): void {
    this.store.dispatch(loadSalesUsers());
  }

  openAddCoinsDialog(salesUser: SalesUser): void {
    const dialogRef = this.dialog.open(AddSalesUserCoinsDialogComponent);
    dialogRef.afterClosed().subscribe((amount: number) => {
      if (amount && amount > 0) {
        this.store.dispatch(changeSalesUserCoins({
          id: salesUser.id,
          model: { coins: amount, operation: 'add' }
        }));
      }
    });
  }
}
